import React, { FC, memo, PropsWithChildren } from "react";
import { usePageWrapper } from "./index.hooks";
import { Box, Container, Icon, Stack } from "@mui/material";
import FsLogo from "assets/fs_logo.svg";
import ProjectPuzzleLogo from "assets/project_puzzle_logo.svg";

type PageWrapperProps = {};

export const PageWrapper: FC<PropsWithChildren<PageWrapperProps>> = memo(
  ({ children }) => {
    const {} = usePageWrapper();

    return (
      <Box
        sx={{
          margin: "auto",
          background: "radial-gradient(#006A5E, #003D36)",
          minHeight: "100vh",
          width: "100vw",
          maxWidth: "100vw",
          overflowX: "hidden",
          position: "relative",
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            p: {
              xs: 3,
              md: 4,
            },
            mb: {
              xs: 3,
              md: 5,
            },
          }}
        >
          <Icon
            sx={{
              textAlign: "center",
              width: "fit-content",
              height: "fit-content",
            }}
          >
            <Box
              component="img"
              src={ProjectPuzzleLogo}
              alt="Project Puzzle"
              sx={{
                height: "auto",
                width: {
                  xs: 120,
                  md: 150,
                },
              }}
            />
          </Icon>
          <Icon
            sx={{
              textAlign: "center",
              width: "fit-content",
              height: "fit-content",
            }}
          >
            <Box
              component="img"
              src={FsLogo}
              alt="Project Puzzle"
              sx={{
                height: {
                  xs: 40,
                  md: 56,
                },
                width: "auto",
              }}
            />
          </Icon>
        </Stack>
        {children}
      </Box>
    );
  },
);
